import {addLocaleData} from 'react-intl';
import Salang from './entries/ar_SA';
import Enlang from './entries/en-US';
import Eslang from './entries/es_ES';
import Frlang from './entries/fr_FR';
import Itlang from './entries/it_IT';
import ThLang from './entries/th_TH';
import Zhlang from './entries/zh-Hans-CN';
import IsLang from './entries/is_IS';

const AppLocale = {
    en: Enlang,
    zh: Zhlang,
    sa: Salang,
    it: Itlang,
    es: Eslang,
    fr: Frlang,
    th: ThLang,
    is: IsLang,
};
addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.zh.data);
addLocaleData(AppLocale.sa.data);
addLocaleData(AppLocale.it.data);
addLocaleData(AppLocale.es.data);
addLocaleData(AppLocale.fr.data);
addLocaleData(AppLocale.th.data);
addLocaleData(AppLocale.is.data);

export default AppLocale;



// WEBPACK FOOTER //
// ./src/languageProvider/index.ts